import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
export function OwnerFinderHero() {
  const [activeRow, setActiveRow] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveRow(prev => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  const owners = [{
    business: 'Grand Central Bakery',
    owner: 'Sarah Johnson',
    title: 'Owner',
    email: 'sarah@grandcentralbakery.com'
  }, {
    business: 'Local Pet Supplies',
    owner: 'Mark Rivera',
    title: 'Founder',
    email: 'mark@localpetsupplies.com'
  }, {
    business: 'Bright Smile Dental',
    owner: 'Dr. Amy Chen',
    title: 'Owner',
    email: 'amy@brightsmile.com'
  }];
  return <section className="relative pt-16 pb-24 overflow-hidden bg-white" data-id="element-5943">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-5944">
        <a href="#/features" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-5945">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-5946" /> All features
        </a>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-5947">
          {/* Left Column: Copy & CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-5948">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-slate-900 mb-8 leading-[1.05]" data-id="element-5949">
              Find local business <br data-id="element-5950" />
              <span className="text-blue-600" data-id="element-5951">owners</span> in minutes
            </h1>

            <p className="text-xl sm:text-2xl text-slate-600 mb-8 max-w-lg leading-relaxed" data-id="element-5952">
              Search 200M+ local businesses and instantly find business owner
              contacts —{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-blue-50 text-blue-700 text-lg sm:text-xl font-medium mx-1" data-id="element-5953">
                verified emails
              </span>
              ,{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-green-50 text-green-700 text-lg sm:text-xl font-medium mx-1" data-id="element-5954">
                verified owner contacts
              </span>
              , and{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-purple-50 text-purple-700 text-lg sm:text-xl font-medium mx-1 mt-2 sm:mt-0" data-id="element-5955">
                verified direct phones
              </span>{' '}
              for every decision-maker.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-5956">
              <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="px-10 py-4 text-white font-bold bg-blue-600 rounded-full hover:bg-blue-700 transition-colors text-lg text-center" data-id="element-5957">
                Try for free
              </a>
            </div>

            {/* Static Stats Bar */}
            <div className="flex gap-12 pt-8" data-id="element-5958">
              <div data-id="element-5959">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-5960">
                  200M+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-5961">
                  Local businesses
                </div>
              </div>
              <div data-id="element-5962">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-5963">
                  50+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-5964">
                  Data points per business
                </div>
              </div>
              <div data-id="element-5965">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-5966">
                  Built-in
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-5967">
                  Sequencing
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Live Data Preview Card */}
          <div className="relative" data-id="element-5968">
            <div className="bg-slate-50 rounded-[2rem] p-8 sm:p-10 relative z-10" data-id="element-5969">
              <div className="flex justify-between items-center mb-8" data-id="element-5970">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-5971">
                  Owner finder preview
                </h3>
              </div>

              <div className="overflow-x-auto" data-id="element-5972">
                <table className="w-full text-sm text-left" data-id="element-5973">
                  <thead data-id="element-5974">
                    <tr className="text-slate-400 font-medium border-b border-slate-200/60" data-id="element-5975">
                      <th className="pb-4 pl-4 pr-4 font-medium" data-id="element-5976">Business</th>
                      <th className="pb-4 px-4 font-medium" data-id="element-5977">Owner</th>
                      <th className="pb-4 px-4 font-medium" data-id="element-5978">Title</th>
                      <th className="pb-4 pl-4 font-medium" data-id="element-5979">Email</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200/60" data-id="element-5980">
                    {owners.map((row, idx) => <tr key={idx} className={`transition-all duration-500 relative ${activeRow === idx ? 'bg-white shadow-sm rounded-xl' : ''}`} data-id="element-5981">
                        <td className="py-6 pl-4 pr-4 font-medium text-slate-900 rounded-l-xl whitespace-nowrap" data-id="element-5982">
                          {row.business}
                        </td>
                        <td className="py-6 px-4 text-slate-700 whitespace-nowrap" data-id="element-5983">
                          {row.owner}
                        </td>
                        <td className="py-6 px-4 text-slate-500 whitespace-nowrap" data-id="element-5984">
                          {row.title}
                        </td>
                        <td className="py-6 pl-4 rounded-r-xl" data-id="element-5985">
                          <div className="text-blue-600 font-medium truncate max-w-[150px] sm:max-w-none" data-id="element-5986">
                            {row.email}
                          </div>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-200/60 flex justify-end" data-id="element-5987">
                <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors" data-id="element-5988">
                  Find business owners
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}